import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environmentConfig } from '../../environment';
import { Observable, throwError, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorService {
  private apiUrl = environmentConfig.apiBaseUrl;
  constructor(private http: HttpClient) { }
  private fetchAuthenticated(
    url: string,
    method: 'GET' | 'POST',
    bodyData?: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      //'Authorization': (token != null) ? `Bearer ${token}` : ``,
      'Content-Type': 'application/json'
    });
    const httpOptions = { headers };
    let httpCall: Observable<any>;

    if (method === 'GET') {
      httpCall = this.http.get(url, httpOptions);
    } else if (method === 'POST') {
      httpCall = this.http.post(url, bodyData, httpOptions);
    } else if (method === 'PUT') {
      httpCall = this.http.put(url, bodyData, httpOptions);
    } else {
      return throwError(() => new Error('Unsupported method'));
    }

    return httpCall.pipe(
      catchError(error => {
        console.error('❌ HTTP Error:', error);
        return throwError(() => error);
      })
    );
  }

  check2FA(email: string, hostname:string): Promise<any> {
    const url = `${this.apiUrl}/api/check2FA?email=${email}&hostname=${hostname}`;
    return this.fetchAuthenticated(url, 'GET', null).toPromise();
  }

  send2FAEmail(email: string): Promise<any> {
      const url = `${this.apiUrl}/api/send2FA?email=${encodeURIComponent(email)}`;
      return this.fetchAuthenticated(url, 'GET', null).toPromise();
  }

  verifyCode(email: string, code: string): Promise<any> {
    const url = `${this.apiUrl}/api/verifycode?e=${email}&c=${code}`;
    return this.fetchAuthenticated(url, 'GET', null).toPromise();
  }

  updateUserRecord(email: string, remember: number | 0): Promise<any> {
    const url = `${this.apiUrl}/api/postlogin?e=${email}&r=${remember}`;
    return this.fetchAuthenticated(url, 'GET', null).toPromise();
  }


  //sendMessage(userid: number, json: object | null, token: string): Promise<any> {
  //  console.log("JSON", json)
  //  const url = `${this.apiUrl}/api/smc/sendmsg?userid=${userid}`;
  //  return this.fetchAuthenticated(url, 'POST', token, json).toPromise();
  //}

}

